import React, { Component } from "react";
import { Navigate, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import {Formik, Field, Form, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import {Modal} from "react-bootstrap";
import { registerUserAction } from 'actions/authenticationActions';
import { fetchDistrictAction } from 'actions/localityActions';
import HomeNav from "components/Navbars/HomeNav.js";
import HomePageHeader from "components/Headers/HomePageHeader.js";
import DefaultFooter from "components/Footers/DefaultFooter.js";

// reactstrap components
import {
  Card,
  CardHeader,
  Container,
  Row,
  CardTitle,
  CardBody,
  Input,
  InputGroupText,
  InputGroup,
  Label,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Button
} from "reactstrap";

class AdminSignupPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstFocus: false,
      lastFocus: false,
      country: '',
      stateLocation: '',
      secdistrictOptions: [],
      modalOKEnabled: false,
      show: false      
    }
    this.setShow = this.setShow.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.stateFilterChanged = this.stateFilterChanged.bind(this);
    this.districtFilterClicked = this.districtFilterClicked.bind(this);
  }

  componentWillMount() {
    document.title = 'Register Administrator';

    if (!this.props.response.login.isSignedIn) {
      //user not logged in..redirect to login page
      this.props.response.login.redirectAfterSignInTo = '/liquidlove/register-admin';
    }
    else{
      this.state.country = this.props.response.login.adminCountry;
      this.state.stateLocation = this.props.response.login.adminStateLocation;
      this.state.district = this.props.response.login.adminDistrict;
    }

    const districtPayload = {
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      token: this.props.response.login.userToken,
    };

    this.props.dispatch(fetchDistrictAction(districtPayload));
  }

  componentWillUnmount() {

    if(this.props.response.register.response !== 'undefined')
      delete this.props.response.register.response;

    if(this.props.response.locality.response !== 'undefined')
      delete this.props.response.locality.response;      
  }

  stateFilterChanged(e){
    this.state.stateLocation = e.target.text;

    const districtPayload = {
      country: this.state.country,
      stateLocation: this.state.stateLocation,
      token: this.props.response.login.userToken,
    };
        
    if (this.props.response.login.isSignedIn) {   
      this.props.dispatch(fetchDistrictAction(districtPayload));
    }
  }

  districtFilterClicked(e){
    this.state.district = e.target.value;
  }

  setShow(bool) {
    this.setState({ show: bool });
  }

  handleClose = () => { 
    this.setShow(false)
    this.props.navigate('/liquidlove/home');
  };
  
  handleShow = () => { this.setShow(true) };

  render() {
    if (!this.props.response.login.isSignedIn) {
      return <Navigate to={'/liquidlove/login'} />
    }

    let message;
    
    message = 'Sairam! Processing your request';
    if(!(this.props.response.login.isSuperAdmin || this.props.response.login.isStateAdmin)){
      this.state.modalOKEnabled = true;
      message =  'Sairam! You dont have access to register a new admin';
    }
    else if (this.props.response.register.hasOwnProperty('response')){
      this.state.modalOKEnabled = true;
      if(this.props.response.register.response.hasOwnProperty('status'))
        if(this.props.response.register.response.status === 'success')
          message = 'Sairam! Sign-up is successful and email sent to new administrator';
        else if(this.props.response.register.response.status === 'error'){
          this.props.response.register.response.message ?
            message = this.props.response.register.response.message :
            message = 'Sairam! Sign-up is NOT successful';
        }
    }
    
    this.state.secdistrictOptions = [];

    if (this.props.response.locality.hasOwnProperty('response'))
      if(this.props.response.locality.response  && this.props.response.locality.response.districts){
        this.state.district = this.props.response.locality.response.districts[0];
        
        this.props.response.locality.response.districts.map((secDistrict) => {
          let secdistrictItem = {value: '', label: ''}; 
          secdistrictItem.value = secDistrict;
          secdistrictItem.label = secDistrict;
          this.state.secdistrictOptions.push(secdistrictItem);                 
        })            
      }

    return (      
      <Formik
            initialValues={{
                username: '',
                email: '',
                phone: '',
                ctry: '',
                stateLo: '',
                dist: '',  
                role: [],
                secDistricts: []
            }}
            validationSchema={Yup.object().shape({
              username: Yup.string()
                    .required('username is required'),              
              email: Yup.string()
                    .required('email is required')
                    .email('email is invalid'),
              phone: Yup.number()                
                    .required('phone is required')
                    .test('len', 'Please enter 10 digits', val => val && val.toString().length === 10 )                
                    .positive('Please provide valid phone number'),
            })}
        onSubmit={fields => {
            let username = fields.username;            
            let email = fields.email;
            let phone = fields.phone;
            let secondaryDistricts = fields.secDistricts;
            let country = this.state.country;
            let stateLocation = this.state.stateLocation;
            let district   = this.state.district;
            let role = fields.role;
            const data = {
              username, email, phone, country, stateLocation, district, role, secondaryDistricts
            }
            const payload = {
              data,
              token: this.props.response.login.userToken
            }
            if(this.props.response.login.isSuperAdmin ||
              this.props.response.login.isStateAdmin){
                message = 'Sairam! Processing your request';
                this.handleShow();
                this.props.dispatch(registerUserAction(payload));
            }
        }  
      }
        render={({ errors, status, touched }) => (                    
          <div className="wrapper">
            <HomePageHeader /><HomeNav adminName={this.props.response.login.adminName}/>
            <div  className="section section-signup"
              style={{
                backgroundImage: "url(" + require("assets/img/shivaratri-wallpapers-6.png") + ")",
                backgroundSize: "cover",
                backgroundPosition: "top center",
                minHeight: "700px",
              }}
            >
              <Container>
                <Row>
                  <Card className="card-signup" data-background-color="blue">
                    <CardHeader className="text-center">
                        <CardTitle className="title-up" tag="h3">
                            Liquid Love Admin Signup                            
                        </CardTitle>                  
                    </CardHeader>
                    <CardBody>
                      <UncontrolledDropdown disabled={!this.props.response.login.isSuperAdmin}  className="btn-group" size="sm">
                  <DropdownToggle
                    aria-expanded={false}
                    aria-haspopup={true}
                    caret
                    color="primary"
                    data-toggle="dropdown"
                    type="button"
                  >
                    State
                  </DropdownToggle>
                  <DropdownMenu style={{overflowY: 'scroll', maxHeight: "300px" }}>                    
                  {this.props.response.locality.response && this.props.response.locality.response.stateLocations ? 
                    this.props.response.locality.response.stateLocations.map((stateLocation) => (
                    <DropdownItem active={this.state.stateLocation === stateLocation} href={stateLocation} onClick={e => {e.preventDefault(); this.stateFilterChanged(e)}}>{stateLocation}</DropdownItem>
                    )) : ''}
                  </DropdownMenu>
                </UncontrolledDropdown>&nbsp;&nbsp;{this.state.stateLocation}<br/>
                Primary District <select onChange={e => {this.districtFilterClicked(e)}} id="dt">
                  {this.props.response.locality.response && this.props.response.locality.response.districts ?                     
                    this.props.response.locality.response.districts.map((district) => (
                    <option onClick={e => {this.districtFilterClicked(e)}} selected={this.state.district === district} value={district}>{district}</option>
                    )) : ''}
                </select><br/><br/>                      
                      <Form>
                      <Modal
                        centered
                        show={this.state.show}
                        onHide={this.handleClose}
                        backdrop="static"
                        keyboard={false}
                        >
                          <Modal.Body>
                            {message}
                          </Modal.Body>
                          <Modal.Footer>
                            <Button disabled={!this.state.modalOKEnabled} className="btn btn-primary mr-2" variant="primary" onClick={this.handleClose}>
                              OK
                            </Button>
                          </Modal.Footer>
                        </Modal>
                      <Field hidden name="ctry" value={this.state.country} type="text"  />
                      <Field hidden name="stateLoc" value={this.state.stateLocation} type="text"  />
                      <Field hidden name="dist" value={this.state.district} type="text"  />
                      <InputGroup
                    className={
                      "no-border" + (this.state.firstFocus ? " input-group-focus" : "")
                    }
                  >

                      <InputGroupText>
                        Secondary districts
                      </InputGroupText>
                      <h12>Hold down the control (ctrl) or (command) to select multiple districts</h12>
                      <Field name="secDistricts" component="select" multiple={true} size="5" id="secdt">
                      {this.props.response.locality.response && this.props.response.locality.response.districts ?                     
                          this.props.response.locality.response.districts.map((secDis) => (
                        <option value={secDis}>{secDis}</option>
                    )) : ''}
                      </Field>
                      </InputGroup>
                      <InputGroup
                    className={
                      "no-border" + (this.state.firstFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        Username
                      </InputGroupText>
                    <Field name="username" type="text" className={'form-control' + (errors.username && touched.username ? ' is-invalid' : '')} />
                    <ErrorMessage name="username" component="div" className="invalid-feedback" />
                  </InputGroup>
                  <InputGroup
                    className={
                      "no-border" + (this.state.firstFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        email
                      </InputGroupText>
                    <Field name="email" type="text" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} />
                    <ErrorMessage name="email" component="div" className="invalid-feedback" />
                  </InputGroup>
                  <InputGroup
                    className={
                      "no-border" + (this.state.firstFocus ? " input-group-focus" : "")
                    }
                  >
                      <InputGroupText>
                        Phone
                      </InputGroupText>
                    <Field name="phone" type="text" className={'form-control' + (errors.phone && touched.phone ? ' is-invalid' : '')} />
                    <ErrorMessage name="phone" component="div" className="invalid-feedback" />
                  </InputGroup><br/>                                                      
                  <div role="group" aria-labelledby="my-radio-group">
                          Roles<br></br>
                        <Label check>
                          <Field checked disabled
                            id="Admin"
                            name="role"
                            type="checkbox"
                            value="Admin"                            
                          ></Field>
                          &nbsp;Admin <span className="form-check-sign"></span>
                        </Label>                        
                        &nbsp;&nbsp;&nbsp;&nbsp;                        
                        <Label check>
                          <Field
                            disabled={!this.props.response.login.isSuperAdmin}
                            id="State Admin"
                            name="role"
                            type="checkbox"
                            value="State Admin"                            
                          ></Field>
                          &nbsp;State Admin <span className="form-check-sign"></span>
                        </Label>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <Label check>
                          <Field
                            disabled={!this.props.response.login.isSuperAdmin}
                            id="Super Admin"
                            name="role"
                            type="checkbox"
                            value="Super Admin"
                          ></Field>
                          &nbsp;Super Admin <span className="form-check-sign"></span>
                        </Label>                      
                        </div>
                  <div className="col text-center">
                  <button
                    disabled={!(this.props.response.login.isSuperAdmin || this.props.response.login.isStateAdmin)}                      
                    type="submit" 
                    size="lg" outline className="btn btn-primary">                    
                    Register
                  </button>
                  </div>
                      </Form>
                    </CardBody>                             
                </Card>
              </Row>
            </Container>                
          </div>
          <DefaultFooter />
        </div>
        )}
      />
    )
}};

const mapStateToProps = (response) => ({response});

export default connect(mapStateToProps)((props) => {
  const navigate = useNavigate();
  return <AdminSignupPage navigate={navigate} {...props} />
});